import React, { useState, useEffect } from "react";
import axios from "axios";
import Navbar from "../Components/Navbar";
import { useNavigate } from "react-router-dom";
import jwt_decode from "jwt-decode";

const Search = () => {
  const [supplierData, setSupplierData] = useState([]);
  const [user, setUser] = useState("");
  const [userName, setUserName] = useState("");

  const [searchName, setSearchName] = useState("");
  const [searchId, setSearchId] = useState("");

  const navigate = useNavigate();
  const fetchSupplierData = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_API_BASEURL + "/supplierNames");
      return response.data;
    } catch (error) {
      console.error("Error fetching supplier data:", error);
      return [];
    }
  };
  useEffect(() => {
    fetchSupplierData().then((data) => setSupplierData(data));
  }, []);
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const decoded = jwt_decode(token);
      const user = decoded.user;
      const userName = decoded.username;
      setUser(user);
      setUserName(userName);
    } else {
      console.error("Token not found in localStorage.");
    }
  }, []);

  const handleSupplierClick = async (supplier) => {
    fetchSupplierDataForHome(supplier);
    localStorage.setItem("currentUser", supplier.supplier);
    localStorage.setItem("supplierName", supplier.name);
    navigate(`/Home`);
  };

  return (
    <>
      <div className="container-login100">
        <div className="wrap-login100">
          <Navbar />
          <div className="tableft">
            <a>Search</a>
          </div>
          <div className="margin_top" id="result-wrapper">
            <div className="UserDetailsLabel">
              <div className="UserName">Inloggad som: {user}</div>
              <div className="UserEmail">{userName}</div>
            </div>
            <div className="wrap-search">
              <table id="searchdetail">
                <tbody>
                  <tr>
                    <td colSpan="2">
                      <div
                        className="wrap-input100 validate-input m-t-85 m-b-35"
                        data-validate="Enter username"
                      >
                        <label>Live name</label>

                        <input
                          className="input100"
                          id="farmersName"
                          name="farmersname"
                          type="text"
                          onChange={(e) => setSearchName(e.target.value)}
                        />

                        <span
                          className="focus-input100"
                          data-placeholder="FarmersName"
                        />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan="2">
                      <div
                        className="wrap-input1002 validate-input m-b-50"
                        data-validate="Enter password"
                      >
                        <label>Live ID</label>

                        <input
                          className="input100"
                          id="farmersId"
                          name="farmersid"
                          type="text"
                          onChange={(e) => setSearchId(e.target.value)}
                        />

                        <span
                          className="focus-input100"
                          data-placeholder="FarmersID"
                        />
                      </div>
                    </td>
                  </tr>
                  <tr className="search-results">
                    <td colSpan="2" id="search-result-count">
                      {supplierData.length} Members
                    </td>
                  </tr>
                  <tr className="heading" id="heading">
                    <td>Name (Click on supplier to see details)</td>
                    <td className="ral">ID</td>
                  </tr>
                  {supplierData.filter((supplier) => {
                    // If searchName has some value, then ensure supplier.name includes searchName
                    if (searchName) {
                      return supplier.name.toLowerCase().includes(searchName.toLowerCase());
                    } else {
                      return true;
                    }
                  }).filter( (supplier) => {
                    // If searchId has some value, then ensure supplier.supplier includes searchId
                    if (searchId) {
                      return supplier.supplier.toLowerCase().includes(searchId.toLowerCase());
                    } else {
                      return true;
                    }
                  } ).map((supplier, index) => (
                    <tr
                      key={index}
                      onClick={() => handleSupplierClick(supplier)}
                      style={{ cursor: "pointer" }}
                    >
                      <td className="odd">
                        <a className="Viewing-cap">{supplier.name}</a>
                      </td>
                      <td className="odd ral" id="clickbox">
                        <a className="Viewing-cap">{supplier.supplier}</a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export const fetchSupplierDataForHome = async (supplierId) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(process.env.REACT_APP_API_BASEURL + "/api/Home/supplierdata/" + supplierId, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data; // Return the data
  } catch (error) {
    console.error("Error fetching supplier data for Home:", error);
    throw error;
  }
};

export default Search;
